import PropTypes from "prop-types";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

function DeleteProposalDialog({ open, onClose, proposals, handleDelete }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Proposal</DialogTitle>

      <DialogContent>
        <Typography variant="body2">
          {proposals?.length === 1 ? (
            <>
              Are you sure you want to delete proposal{" "}
              <strong>{proposals[0]?.code || proposals[0]?.title}</strong>?
            </>
          ) : (
            <>
              Are you sure you want to delete{" "}
              <strong>{proposals?.length}</strong> proposals?
            </>
          )}
        </Typography>

        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          This action can be reverted only by administrators.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button variant="contained" color="error" onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeleteProposalDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  proposals: PropTypes.arrayOf(PropTypes.object),
  handleDelete: PropTypes.func.isRequired,
};

DeleteProposalDialog.defaultProps = {
  proposals: [],
};

export default DeleteProposalDialog;
